import { Notification } from "@tql/ui-components-react/kendo/notification";
import { useState } from "react";

export const DISPATCH_CANCELLATION_MESSAGE =
	"Dispatch cancellation in progress. This may take a few moments.";
export const SHIPMENT_CANCELLATION_MESSAGE =
	"Cancelling shipment. This may take a few moments.";

type CancellationBannerProps = {
	readonly isCancellingShipment: boolean;
	readonly isCancellingDispatch: boolean;
	readonly shipmentState: number | undefined;
};

export const CancellationBanner = ({
	isCancellingShipment,
	isCancellingDispatch,
	shipmentState,
}: CancellationBannerProps) => {
	const hasDispatch = (shipmentState ?? 0) > 0;
	// Latch whether the shipment was dispatched when the cancel started; the
	// post-void refetch can reset the state before the mutation settles.
	const [voidCancelsDispatch, setVoidCancelsDispatch] = useState(hasDispatch);
	if (!isCancellingShipment && voidCancelsDispatch !== hasDispatch) {
		setVoidCancelsDispatch(hasDispatch);
	}

	const isDispatchCancellation =
		isCancellingDispatch || (isCancellingShipment && voidCancelsDispatch);

	if (!isDispatchCancellation && !isCancellingShipment) {
		return null;
	}

	return (
		<div
			aria-live={"polite"}
			className={"cancellation-banner"}
			data-testid={"cancellation-banner"}
			role={"status"}
		>
			{isDispatchCancellation ? (
				<Notification type={{ style: "info", icon: true }}>
					{DISPATCH_CANCELLATION_MESSAGE}
				</Notification>
			) : (
				<Notification type={{ style: "info", icon: false }}>
					{SHIPMENT_CANCELLATION_MESSAGE}
				</Notification>
			)}
		</div>
	);
};
